








































import Vue from 'vue';
import { VTextField, VBtn, VSelect } from 'vuetify/lib';

export default Vue.extend({
  components: {
    VTextField,
    VBtn,
    VSelect,
    AiNavGrid: () => import('../AiNavGrid/AiNavGrid.vue'),
    AiIcon: () => import('../AiIcon/AiIcon.vue')
  },
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        const types = ['dataset', 'crm'];
        const valid = types.includes(value);
        if (!valid) console.error(`Provided navbar type '${value}' does not exist`);
        return valid;
      }
    }
  }
});
